import {
  primary,
  secondary,
  blue,
  blueGrey,
  greyscale,
  success,
  error,
  grey,
  warning,
  white,
  black,
  text,
  darkThemeText,
} from "./palette";
import type { Translation } from "../locale/translations";
import { ThemeOptions } from "@mui/material";

declare module "@mui/material/styles" {
  interface Theme {
    custom: {
      palette: {
        light: string;
        dark: string;
        blue: {
          [key: number]: string;
        };
        blueGrey: {
          [key: number]: string;
        };
        warning: {
          [key: number]: string;
        };
        success: {
          [key: number]: string;
        };
        grey: {
          [key: number]: string;
        };
        greyscale: {
          [key: number]: string;
        };
      };
      shadows: Array<string>;
      radius: Array<string>;
    };
    translations?: Translation;
  }
  interface ThemeOptions {
    custom?: {
      palette?: {
        light: string;
        dark: string;
        blue: {
          [key: number]: string;
        };
        blueGrey: {
          [key: number]: string;
        };
        warning: {
          [key: number]: string;
        };
        success: {
          [key: number]: string;
        };
        grey: {
          [key: number]: string;
        };
        greyscale: {
          [key: number]: string;
        };
      };
      shadows?: Array<string>;
      radius?: Array<string>;
    };
    translations?: Translation;
  }
}

export const theme = (mode: "dark" | "light"): ThemeOptions => ({
  palette: {
    mode,
    primary,
    secondary,
    warning,
    error: error,
    success: success,
    grey: greyscale,
    text: mode === "dark" ? darkThemeText : text,
    background: {
      default: mode === "dark" ? "#16181F" : "#F6F9FC",
    },
  },
  components: {
    MuiPaper: { styleOverrides: { root: { background: mode === "dark" ? "#252830" : "white" } } },
  },
  typography: {
    fontFamily: ["Open Sans", "Poppins", "sans-serif"].join(","),
  },
  custom: {
    palette: {
      light: white,
      dark: black,
      blue,
      blueGrey,
      warning,
      success,
      grey,
      greyscale,
    },
    shadows: [
      "none",
      "inset 0px -1px 0px #cedaeb",
      "0px 3px 6px 2px rgba(0, 0, 0, 0.1);",
      "0px 4px 4px rgba(0, 68, 168, 0.1);",
      "0px 12px 17px rgba(0, 0, 0, 0.14), 0px 5px 22px rgba(0, 0, 0, 0.12), 0px 7px 8px rgba(0, 0, 0, 0.2);",
      "0px 0px 17px rgba(0, 0, 0, 0.14), 0px 5px 22px rgba(0, 0, 0, 0.12), 0px 7px 8px rgba(0, 0, 0, 0.2);",
    ],
    radius: ["4px", "8px", "16px"],
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
